import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { CurrencyInput } from "../../../components/CurrencyInput";
import { Button } from "../../../components/Button";

export default class FreeDeliveryDrawer extends React.Component {
  state = {
    loading: false,
    active: true,
    minOrder: 0,
  };

  async componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible === true) {
      const freeDelivery = await EnvironmentsAPI.getConfigurationsByAlias(
        EnvironmentStorage.getSelectedEnvironment(),
        "free_delivery"
      );
  
      this.setState({
        minOrder: freeDelivery?.minOrder
      });
    }
  }

  async save() {
    const { minOrder } = this.state;
    this.setState({ loading: true });

    const updateResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      await EnvironmentStorage.getSelectedEnvironment(),
      "free_delivery",
      { free_delivery: { minOrder }}
    );

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0] });
    }

    this.setState({ loading: false });
  }

  render() {
    const { loading, minOrder } = this.state;
    const { visible, onClose } = this.props;

    const saveMessage = minOrder > 0 ? `Salvar` : 'Manter frete grátis desabilitado'

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Frete grátis"
      >
        <div className={styles.secretDrawerContainer}>
          <CurrencyInput
            name="min_order"
            design="two"
            floatLabel="Pedido minimo para zerar taxa"
            onChange={(e, m, value) => this.setState({ minOrder: value })}
            value={minOrder}
          />
        </div>
        <div className={styles.footer}>
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.save()}
            loading={loading}
            disabled={loading}
          >
            {saveMessage}
          </Button>
        </div>
      </Drawer>
    );
  }
}
